import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet , useNavigate} from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import SettingsSidebar from '../../../dashboard/components/settings/SettingsSidebar';
import logo from '../../../../assets/images/logos/576_Cash Canvas-02.png';
import { fetchSubscriptionData, selectCurrentPlan, selectSelectedPlan } from '../../../../app/store/slices/subscriptionSlice';
import { selectUser, fetchUserData } from '../../../../app/store/slices/userSlice';
import { CanvasProvider } from '../../../dashboard/context/CanvasContext';


const SettingsLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const user = useSelector(selectUser);
  const selectedPlan = useSelector(selectSelectedPlan);
  const currentPlan = useSelector(selectCurrentPlan);
  const [activeSection, setActiveSection] = useState(() => {
  if (user?.role === 'admin') {
      return 'manage-password';
    }
    return 'manage-canvas';
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await dispatch(fetchSubscriptionData()).unwrap();
        setSubscriptionData(response.data);
      } catch (error) {
        console.error('Failed to fetch subscription data:', error);
      } finally {
        setLoading(false);
      }
    };


    fetchData();
  }, [dispatch]);
  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        await dispatch(fetchUserData()).unwrap();
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      }
    };
    fetchUser();
  }, [dispatch]);

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const iconClick = ()=>{
    if (user?.role === 'admin') {
      navigate('/manage-portal');
    } else {
      navigate('/dashboard');
    }
  }

  if (loading) {
    return (
      <div className="flex justify-center pt-8">
        <div className="relative">
          <div className="h-10 w-10 rounded-full border-t-2 border-b-2 border-blue-600 animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
     <CanvasProvider>
    <div className="min-h-screen bg-gray-50">
      {/* Fixed Header */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-btn-primary shadow-sm">
        <div className="flex items-center justify-between px-4 h-20"> 
          <div className="flex items-center gap-2 md:gap-4">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-md hover:bg-btn-secondary"
            >
              <FaBars className="h-6 w-6 text-white" />
            </button>
            <img 
              src={logo} 
              alt="Cash Canvas" 
              className="h-16 md:h-20 cursor-pointer" 
              onClick={iconClick}
            />
          </div>
          <div className="text-center">
            <h1 className="text-lg md:text-xl text-white font-semibold">Settings</h1>
            {user?.role!=='admin' && (
              <p className="text-xs md:text-sm text-white">
              Plan: {currentPlan?.plan?.name || 'No Subscription Exists'}
             </p>
            )}
          </div>
          <div className="w-10 md:w-16"></div>
        </div>
      </div>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="pt-[80px] min-h-[calc(100vh-80px)] relative">
        {/* Sidebar Container */}
        <div className={`
          fixed left-0 top-20 pr-4 bottom-0 md:bg-transparent
          transform transition-transform duration-300 ease-in-out z-40
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-60'}
          w-[230px] md:w-64
        `}>
          <div className="h-full overflow-y-auto custom-scrollbar">
            <SettingsSidebar 
              activeSection={activeSection}
              onSectionChange={(section) => {
                setActiveSection(section);
                if (window.innerWidth < 768) setIsSidebarOpen(false);
              }}
              isSidebarOpen={isSidebarOpen}
              onToggle={toggleSidebar}
            />
          </div>
        </div>

        {/* Toggle Button */}
        {/* <div className={`hidden md:block fixed z-40 mt-4 transition-transform duration-300 ${
          isSidebarOpen ? 'left-[230px]' : 'left-4'
        }`}>
          <button
            onClick={toggleSidebar}
            className="flex items-center justify-center text-2xl shadow-md hover:shadow-lg p-2 bg-btn-secondary rounded"
          >
            <FaBars className={`text-gray-600 transform transition-transform duration-300 ${
              isSidebarOpen ? '' : 'rotate-180'
            }`} />
          </button>
        </div> */}

        {/* Main Content */}
        <div className={`transition-all duration-300 overflow-y-auto 
          ${isSidebarOpen ? 'md:ml-60' : 'ml-0'} min-h-[calc(100vh-80px)]`}
        > 
          <main className="p-4 bg-gray-50">
            <Outlet context={[activeSection, setActiveSection]} />
          </main>
        </div>
      </div>
    </div>
    </CanvasProvider>
  );
};

export default SettingsLayout;
